let jwtHelperSingleton;

const jwtHelperFactory = function() {
  function JwtHelper() {
    this.jwtKey = '';
    jwtHelperSingleton = this;
  }

  JwtHelper.prototype.setJwtKey = function(jwtKey) {
    this.jwtKey = jwtKey;
  };

  JwtHelper.prototype.getJwtKey = function() {
    if (!this.jwtKey) throw new Error('You forgot to call setJwtKey first');
    return this.jwtKey;
  };

  /**
   * Returns LocalStorages's jwt if present
   */
  JwtHelper.prototype.getJwtFromLocalStorage = function() {
    if (!this.jwtKey) throw new Error(`The "jwtKey" has not been found`);
    // .ls is the default prefix for our storage (in portail-agent and others)
    const jwtKey = localStorage.getItem(this.jwtKey) || localStorage.getItem(`ls.${this.jwtKey}`);
    if (!jwtKey) throw new Error(`key : ${this.jwtKey} not found in the browser's local storage`);
    const { jwt } = JSON.parse(jwtKey);
    return jwt;
  };

  return jwtHelperSingleton ? jwtHelperSingleton : new JwtHelper();
};

jwtHelperFactory();

export { jwtHelperSingleton as jwtHelper };
